import React from 'react';
import { Typography } from '@mui/material';

const Failed: React.FC = () => {
  return (
    <>
      <Typography mt={3} variant="body2" color="textSecondary">
        Thank you for registering. Someone from our team will reach out to you
        with next steps
      </Typography>
    </>
  );
};

export default Failed;
